import React from 'react';

const Label = ({
	required = false,
	name,
	label = null,
}) => {
	return (
		<label>
			{label || name?.replace('.', ' ').replace('_', ' ')}
			{ required && <sup>*</sup> }
		</label>
	);
};

export default Label;
